<template id="drilldown-a">

    <section>
        <div class="row ml-3">
        <iframe src ="https://forewarn.compegence.com:3000/#!/l1/Product%20Category/state"  height="600" width="100%" frameBorder="0"></iframe>
        </div>
    </section>
</template>
<script>
    export default {
        name: "drilldown-a"
    }
</script>
<style>

</style>